import { Logger } from "@/utils/logger";

import { cctpLogContext, type CctpTransferTags } from "./telemetry";

const loggedFailureKeys = new Set<string>();

export function logCCTPFailureOnce(
  err: unknown,
  context: { feature: string; sourceChain: string; sourceTxHash: string },
  transfer?: CctpTransferTags,
): void {
  const key = `${context.feature}:${context.sourceChain}:${context.sourceTxHash}`;
  if (loggedFailureKeys.has(key)) return;
  loggedFailureKeys.add(key);
  Logger.error(err, transfer ? cctpLogContext(transfer, context) : context);
}
